import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ArrowRightIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.26719 11.7456C9.26885 11.744 9.27048 11.7423 9.27215 11.7406L14.3935 6.62595C14.434 6.58531 14.4699 6.5404 14.5006 6.49204L14.581 6.34477L14.6145 6.24435V6.1707C14.6352 6.05785 14.6352 5.94215 14.6145 5.82927V5.76234V5.682L14.5542 5.56818C14.5198 5.50476 14.477 5.4462 14.427 5.39411L9.27215 0.259344C8.93103 -0.0844984 8.37575 -0.0867264 8.0319 0.254386C8.03024 0.256018 8.02861 0.257681 8.02694 0.259344C7.69625 0.605949 7.69625 1.15123 8.02694 1.49786L11.0797 4.5573C11.2091 4.68929 11.207 4.90124 11.075 5.03065C11.0136 5.09088 10.9314 5.12514 10.8454 5.12634H0.877069C0.392702 5.1263 3.05176e-05 5.51891 -9.53674e-07 6.00328C-3.24249e-05 6.48765 0.392576 6.88029 0.876944 6.88035H0.877069H10.8454C11.0302 6.88296 11.178 7.0349 11.1754 7.21974C11.1742 7.30572 11.1399 7.38797 11.0797 7.44939L8.02694 10.4955C7.69198 10.8429 7.69198 11.3932 8.02694 11.7407C8.36806 12.0845 8.92335 12.0867 9.26719 11.7456Z"
        fill="currentColor"
      />
    </svg>
  )
})

ArrowRightIcon.displayName = 'ArrowRightIcon'
